<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader :project="project"></ProjectHeader>
      </div>
      <div class="container-fluid mycontainer-fluid content">
        <div style="width: 700px;margin-top: 40px">
          <div class="modal-content" style="margin-bottom: 20px">
            <div class="modal-body">
              <label
                ><input
                  type="checkbox"
                  v-model="MPTData.UF_IS_MPT"
                  :disabled="MPTData.UF_IS_MPT === 1"
                />
                Запрос направлен {{ MPTData.UF_DATE_MPT }}</label
              >
              <div class="form-group">
                <label>Департамент</label>
                <select
                  class="form-control"
                  v-model="MPTData.UF_DEPARTAMENT_ID"
                  :disabled="!MPTData.IS_CHANGE_DEPARTAMENT"
                >
                  <option
                    v-for="item in directory.departaments"
                    :value="item.ID"
                    >{{ item.NAME }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Комментарий</label>
                <textarea
                  v-model="MPTData.UF_COMMENT_MPT"
                  class="form-control"
                ></textarea>
              </div>
              <button type="button" @click="saveMPT" class="btn btn-info">
                Сохранить
              </button>
            </div>
          </div>
        </div>
        <div v-for="(ltItem, index) in documentConf.LIST_TYPE">
          <div v-if="ltItem.TYPE_LIST_ID">
            <DocumentTable
              :project="project"
              :index="index + 1"
              :docs="ltItem.TYPE_LIST_ID"
              :document-conf="documentConf"
              :document-history="documentHistory"
            ></DocumentTable>
          </div>
          <div v-if="ltItem.CHILD">
            <MultiDocumentTable
              :project="project"
              :index="index + 1"
              :childs="ltItem.CHILD"
              :document-conf="documentConf"
              :document-history="documentHistory"
            ></MultiDocumentTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_DIRECTORY,
  FETCH_PROJECT,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { AUTH_URL } from "@/common/config";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import DocumentTable from "@/components/project/documents/DocumentTable";
import MultiDocumentTable from "@/components/project/documents/MultiDocumentTable";

export default {
  name: "ExpertMPT",
  title: "Заключенение минпромторга",
  data() {
    return {
      documentHistory: false,
      documentConf: [],
      MPTData: {
        UF_IS_MPT: 0,
        UF_DEPARTAMENT_ID: 0,
        IS_CHANGE_DEPARTAMENT: 1,
        UF_COMMENT_MPT: ""
      }
    };
  },
  components: {
    MultiDocumentTable,
    DocumentTable,
    ProjectMenu,
    ProjectHeader
  },
  methods: {
    async fetchMPT() {
      ProjectsService.getZakluchenieMinProm(this.project.ID).then(
        ({ data }) => {
          this.MPTData = data;
        }
      );
    },
    saveMPT() {
      this.MPTData.UF_IS_MPT = 1;
      ProjectsService.editZakluchenieMinProm(
        this.project.ID,
        this.MPTData
      ).then(() => {
        this.fetchMPT();
      }, this);
    },
    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
      await this.$store.dispatch(SET_MAIN_MENU, []);
      if (this.currentUser.TYPE_USER === "manager") {
        ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
          let navMainMenu = [];
          if (data.START_PAGE === "REESTR_PROJECTS") {
            if (data.IS_REESTR_PROJECTS) {
              navMainMenu.push({
                name: "Реестр проектов",
                route: "Projects"
              });
            }
            if (data.IS_REESTR_EXPERTISE) {
              navMainMenu.push({
                name: "Реестр экспертиз",
                route: "Expertise"
              });
            }
          } else {
            if (data.IS_REESTR_PROJECTS) {
              navMainMenu.push({
                name: "Реестр проектов",
                route: "Projects"
              });
            }
            if (data.IS_REESTR_EXPERTISE) {
              navMainMenu.push({
                name: "Реестр экспертиз",
                route: "Expertise"
              });
            }
          }

          navMainMenu.push({
            name: "Заключение минпромторга",
            route: "ExpertMPT",
            params: { id: this.project.ID }
          });
          this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
          this.$store.dispatch(
            SET_IS_VIEW_ALL_EXPERTISE,
            data.IS_VIEW_ALL_EXPERTISE
          );
        });
      }
      this.fetchMPT();

      ProjectsService.getDocumentESProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf = data;
        },
        this
      );
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    }
  },
  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "expertise"
    ])
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["departaments"])
      .then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
    }, this);
  }
};
</script>

<style scoped></style>
